import React, { Component } from 'react';
import { Table, Switch } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer } from '@/components';
import { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({
    _state: rootState.seller,
});
class TableResult extends Component {
    constructor(props) {
        super(props);
        // desc 页码改变
        this.changePage = (page) => {
            dispatch.seller.SET_STATE({
                pageIndex: page,
            });
            dispatch.seller.updateTable({});
        };
        this.state = {
            colums: [
                {
                    title: '序列',
                    dataIndex: 'index',
                    render: (text, record, index) => {
                        const { pageIndex, pageSize } = this.props._state;
                        return (<span>{(pageIndex - 1) * pageSize + index + 1}</span>);
                    },
                },
                {
                    title: '经销商名称（姓名）',
                    dataIndex: 'userName',
                },
                {
                    title: '所属集团',
                    dataIndex: 'groupName',
                },
                {
                    title: '区域',
                    dataIndex: 'area',
                },
                // {
                //   title: '门店',
                //   dataIndex: 'shopName',
                // },
                {
                    title: '所在地',
                    dataIndex: 'location',
                },
                {
                    title: '联系手机号',
                    dataIndex: 'mobile',
                },
                {
                    title: '同步时间',
                    dataIndex: 'createTime',
                },
                {
                    title: '是否展示买家信息给卖家',
                    dataIndex: 'showBuyToSeller',
                    render: (showBuyToSeller, rowData, index) => {
                        return (<Switch checked={Boolean(showBuyToSeller)} onChange={(checked) => {
                            this.changeAsync(checked, rowData);
                        }}/>);
                    },
                },
            ],
        };
        this.changeAsync = this.changeAsync.bind(this);
    }
    componentWillMount() {
        dispatch.seller.updateTable({});
    }
    componentWillUnmount() {
        dispatch.seller.resetState({});
    }
    // desc 改变同步状态
    changeAsync(checked, rowData) {
        const { shopCode, tenantCode } = rowData;
        dispatch.seller.changeAsyncState({
            shopCode,
            tenantCode,
            showBuyToSeller: checked ? 1 : 0,
        });
    }
    render() {
        const state = this.state;
        const { colums } = state;
        const { TableData, tableTotal, pageIndex, pageSize, loading } = this.props._state;
        return (<TableContainer hasExport={false} totalNum={tableTotal}>
        <Table columns={colums} dataSource={TableData} loading={loading} rowKey={(record) => record.id} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: tableTotal,
            onChange: this.changePage,
        }}/>
      </TableContainer>);
    }
}
export default connect(mapStateToProps)(TableResult);
